import { combineReducers } from "redux";
import { topbarReducer } from "./topbar.reducer";
import { toastReducer } from "./toast.reducer";
import { loggedUserReducer } from "./loggedUser.reducer";
import { pageReducer } from "./page.reducer";
import { rightMenuReducer } from "./rightMenu.reducer";
import { usersReducer } from "./users.reducers";
import { AccessPermissionReducer } from "./accesPermissions.reducer";
import { selectedAccountReducer } from "./selectedAccount.reducer";
import { leftMenuReducer } from "./leftMenu.reducer";
import { orderManagementRightMenuReducer } from "./orderManagementRightMenu.reducer"
import { buyerListRightMenuReducer } from "./BuyerListRightMenu.reducer"
import { clientLinkQrCodeDialogReducer } from "./clientLinkQrCodeDialog.reducer"
import { productAcquisitionCostRightMenuReducer } from "./productAcquisitionCostRightMenu.reducer"
import { productManagementListMenuReducer } from "./productManagementListMenu.reducer"
import { purchaseManagementRightMenuReducer } from "./purchaseManagementRightMenu.reducer"
import { expeditionRightMenuReducer } from "./expeditionRightMenu.reducer"
import { shipmentsRightMenuReducer } from "./shipmentsRightMenu.reducer";

const rootReducer = <any>combineReducers({
  topbar: topbarReducer,
  toast: toastReducer,
  loggedUser: loggedUserReducer,
  page: pageReducer,
  leftMenu: leftMenuReducer,
  rightMenu: rightMenuReducer,
  users: usersReducer,
  accessPermissions: AccessPermissionReducer,
  selectedAccount: selectedAccountReducer,
  orderManagementRightMenu: orderManagementRightMenuReducer,
  buyerListRightMenu: buyerListRightMenuReducer,
  clientLinkQrCodeDialog: clientLinkQrCodeDialogReducer,
  productAcquisitionCostRightMenu: productAcquisitionCostRightMenuReducer,
  productManagementListMenu: productManagementListMenuReducer,
  purchaseManagementRightMenu: purchaseManagementRightMenuReducer,
  expeditionRightMenu: expeditionRightMenuReducer,
  shipmentRightMenu: shipmentsRightMenuReducer
})

export { rootReducer }